<template>
  <ubi-form-group :title="$t('posts.edit.equipmentsAndOptionsTitle')">
    <template v-slot:description>
      {{ $t('posts.edit.equipmentsAndOptionsText1') }}
      <br><br>
      {{ $t('posts.edit.equipmentsAndOptionsText2') }}
    </template>
    <el-row>
      <el-button type="primary" @click="dialogTableVisible = true">
        {{ $t('posts.edit.customizeFavoriteEquipment') }}
      </el-button>
      <br /><br />
      <hr />
    </el-row>
    <el-row>
      <el-col :span="12" v-for="(equipment, index) in this.defaultEquipments" :key="index">
        <el-checkbox v-model="post[equipment.code]" true-label="oui" false-label="non">
          {{ equipment.value }}
        </el-checkbox>
      </el-col>
    </el-row>
    <el-row>
      <hr>
    </el-row>
    <el-row>
      <el-form-item>
        <el-autocomplete v-model="selectedEquipment" :fetch-suggestions="querySearch" :placeholder="$t('posts.edit.lookForEquipmentPlaceholder')" @select="handleSelect" style="width: 328px;"></el-autocomplete>
        <el-tooltip placement="top-start">
          <div slot="content" v-html="$t('posts.edit.tooltipEquipementsAndOptions')"/>
          <em class="el-icon-question"></em>
        </el-tooltip>

        <el-button type="text" @click="dialogTableVisible = true">
          {{ $t('posts.edit.seeAvailableEquipmentsList') }}
        </el-button>
      </el-form-item>
    </el-row>
    <el-row v-if="comfortTags.length > 0">
      <el-form-item :label="$t('posts.comfortEquipmentsTitle')">
        <el-tag v-for="tag in comfortTags" :key="tag.name" closable @close="handleClose(tag)">
          {{ tag.name }}
        </el-tag>
      </el-form-item>
    </el-row>
    <el-row v-if="securityTags.length > 0">
      <el-form-item :label="$t('posts.securityEquipmentsTitle')">
        <el-tag v-for="tag in securityTags" :key="tag.name" closable @close="handleClose(tag)">
          {{ tag.name }}
        </el-tag>
      </el-form-item>
    </el-row>
    <el-row v-if="otherTags.length > 0">
      <el-form-item :label="$t('posts.otherEquipmentsTitle')">
        <el-tag v-for="tag in otherTags" :key="tag.name" closable @close="handleClose(tag)">
          {{ tag.name }}
        </el-tag>
      </el-form-item>
    </el-row>

    <el-row>
      <el-form-item>
        <span style="line-height: 1.5; font-size: 0.8125rem; font-weight: bolder;">{{ $t('posts.edit.otherEquipements') }}</span>
        <span style="line-height: 1.5; font-size: 0.75rem;">
          <em class="el-icon-warning"></em>
          {{ $t('posts.edit.otherEquipementsInfos') }}
        </span>
        <el-input type="textarea" v-model="post.equipements_non_qualifies">
        </el-input>
      </el-form-item>
    </el-row>

    <el-row>
      <el-form-item>
        <span style="line-height: 1.5; font-size: 0.8125rem; font-weight: bolder;">{{ $t('posts.edit.otherInformation') }}</span>
        <span style="line-height: 1.5; font-size: 0.75rem;">
          <em class="el-icon-warning"></em>
          {{ $t('posts.edit.otherInformationInfos') }}
        </span>
        <el-input type="textarea" v-model="post.commentaire_public_vo">
        </el-input>
      </el-form-item>
    </el-row>

    <el-dialog :title="$t('posts.edit.availableEquipmentsList')" :visible.sync="dialogTableVisible">
      <el-row>
        {{ $t('posts.edit.maxFavoriteEquipments') }} : <span v-bind:style="getStyleNbFavoriteEquipment()">{{ nbFavoriteEquipments }}</span> / {{ equipments.length }}
        <el-tooltip placement="top-start">
          <div slot="content" v-html="$t('posts.edit.maxFavoriteEquipmentsTip', {max: nbFavoriteEquipmentsMax})"/>
          <em class="el-icon-question"></em>
        </el-tooltip>
        <br />
      </el-row>
      <br />
      <el-form-item>
        <h3>{{ $t("posts.comfortEquipmentsTitle") }}</h3>
        <el-row>
          <el-col v-for="(equipment, index) in comfortEquipments" :span="8" v-if="equipment && equipment.value" :key="index">
            <input type="checkbox" :value="equipment.code" :checked="codesFavoritesEquipments[equipment.code]" v-on:input="selectedFavoriteEquipment(equipment.code, $event.target.checked)" />
            {{ equipment.value }}
          </el-col>
        </el-row>
        <br>
        <h3>{{ $t("posts.securityEquipmentsTitle") }}</h3>
        <el-row>
          <el-col v-for="(equipment, index) in securityEquipments" :span="8" v-if="equipment && equipment.value" :key="index">
            <input type="checkbox" :value="equipment.code" :checked="codesFavoritesEquipments[equipment.code]" v-on:input="selectedFavoriteEquipment(equipment.code, $event.target.checked)" />
            {{ equipment.value }}
          </el-col>
        </el-row>
        <br>
        <h3>{{ $t("posts.otherEquipmentsTitle") }}</h3>
        <el-row>
          <el-col v-for="(equipment, index) in otherEquipments" :span="8" v-if="equipment && equipment.value" :key="index">
            <input type="checkbox" :value="equipment.code" :checked="codesFavoritesEquipments[equipment.code]" v-on:input="selectedFavoriteEquipment(equipment.code, $event.target.checked)" />
            {{ equipment.value }}
          </el-col>
        </el-row>
        <el-row>
          <br />
          <hr />
        </el-row>
        <el-row>
          <el-button type="primary" @click="saveEquipments()" style="float:right;" :disabled="nbFavoriteEquipments > nbFavoriteEquipmentsMax">
            {{ $t("posts.edit.legalNotices.buttonSave") }}
          </el-button>
        </el-row>
      </el-form-item>
    </el-dialog>
  </ubi-form-group>
</template>
<script>

import {
  getAdvertiserEquipments,
  getComfortEquipments,
  getDefaultEquipments, getOtherEquipments, getSecurityEquipments,
  postAdvertiserEquipments
} from '@/services/equipment'

export default {
  name: 'PostEditVoEquipements',
  props: ['post'],
  data () {
    return {
      equipments: [],
      defaultEquipments: [],
      comfortEquipments: [],
      securityEquipments: [],
      otherEquipments: [],
      comfortTags: [],
      securityTags: [],
      otherTags: [],
      selectedEquipment: '',
      dialogTableVisible: false,
      codesFavoritesEquipments: {},
      selectedFavoritesEquipments: [],
      idEquipements: null,
      nbFavoriteEquipments: 0,
      nbFavoriteEquipmentsMax: 20
    }
  },
  watch: {
    post: {
      handler () {
        // Réinitialiser les tags avant de les repeupler pour éviter les doublons et refléter l'état actuel
        this.comfortTags = []
        this.securityTags = []
        this.otherTags = []

        Object.entries(this.post).forEach(entry => {
          const key = entry[0]
          const value = entry[1]

          // Flags Sitimmo : 'oui' (saisie) ou true (GET brut / result.ad)
          if (!this.isEquipmentSelected(value)) {
            return
          }

          // we add it to comfort equipment tags
          const comfortEquipment = this.comfortEquipments.find(equipment => equipment.code === key)
          if (comfortEquipment !== undefined) {
            const tag = { name: comfortEquipment.value, type: '' }
            this.addTagIfNotExists(this.comfortTags, tag)
            return
          }

          // we add it to security equipment tags
          const securityEquipment = this.securityEquipments.find(equipment => equipment.code === key)
          if (securityEquipment !== undefined) {
            const tag = { name: securityEquipment.value, type: '' }
            this.addTagIfNotExists(this.securityTags, tag)
            return
          }

          // we add it to other equipment tags
          const otherEquipment = this.otherEquipments.find(equipment => equipment.code === key)
          if (otherEquipment !== undefined) {
            const tag = { name: otherEquipment.value, type: '' }
            this.addTagIfNotExists(this.otherTags, tag)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    querySearch (queryString, cb) {
      const equipments = this.equipments
      const results = queryString ? equipments.filter(this.createFilter(queryString)) : equipments
      // call callback function to return suggestions
      cb(results)
    },
    createFilter (queryString) {
      return (equipment) => {
        // Suppression des accents et mise en minuscule
        queryString = this.suppAccent(queryString)
        const equipmentSansAccent = this.suppAccent(equipment.value)
        if (equipmentSansAccent.includes(queryString)) {
          return true
        } else {
          return false
        }
      }
    },
    suppAccent (str) {
      const accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g // C, c
      ]
      const noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c']

      for (let i = 0; i < accent.length; i++) {
        str = str.replace(accent[i], noaccent[i])
      }

      return str.toLowerCase()
    },
    handleSelect () {
      // we get the equipment category
      const equipmentCategory = this.getEquipmentCategory(this.selectedEquipment)

      // add it to the corresponding tags
      const tag = { name: this.selectedEquipment, type: '' }
      switch (equipmentCategory) {
        case 'comfort' : this.addTagIfNotExists(this.comfortTags, tag); break
        case 'security' : this.addTagIfNotExists(this.securityTags, tag); break
        case 'other' : this.addTagIfNotExists(this.otherTags, tag); break
      }

      // add it to post (Vue 2 : $set pour les codes absents du GET)
      for (const equipment of this.equipments) {
        if (equipment.value === this.selectedEquipment) {
          this.$set(this.post, equipment.code, 'oui')
        }
      }

      // initialize input
      this.selectedEquipment = ''
    },
    addTagIfNotExists (tags, tag) {
      if (!tags.some(t => t.name === tag.name)) {
        tags.push(tag)
      }
    },
    handleClose (tag) {
      // we get the equipment category
      const equipmentCategory = this.getEquipmentCategory(tag.name)

      // remove it from the corresponding tags
      switch (equipmentCategory) {
        case 'comfort' : this.comfortTags.splice(this.comfortTags.indexOf(tag), 1); break
        case 'security' : this.securityTags.splice(this.securityTags.indexOf(tag), 1); break
        case 'other' : this.otherTags.splice(this.otherTags.indexOf(tag), 1); break
      }

      // Explicit 'non' (same as default checkboxes) so Sitimmo persists the removal
      for (const equipment of this.equipments) {
        if (equipment.value === tag.name) {
          this.$set(this.post, equipment.code, 'non')
        }
      }
    },
    isEquipmentSelected (value) {
      return value === 'oui' || value === true
    },
    getEquipmentCategory (equipment) {
      if (this.comfortEquipments.some(comfortEquipment => comfortEquipment.value === equipment)) {
        return 'comfort'
      } else if (this.securityEquipments.some(securityEquipment => securityEquipment.value === equipment)) {
        return 'security'
      } else {
        return 'other'
      }
    },
    loadDefaultEquipments () {
      return getDefaultEquipments(this.$labels)
    },
    loadComfortEquipments () {
      this.$labels.cd = this.$t('posts.edit.cd')
      return getComfortEquipments(this.$labels)
    },
    loadSecurityEquipments () {
      return getSecurityEquipments(this.$labels)
    },
    loadOtherEquipments () {
      return getOtherEquipments(this.$labels)
    },
    upperCaseFirstLetterOfValue (equipments) {
      equipments.forEach(equipment => equipment.value = equipment.value.charAt(0).toUpperCase() + equipment.value.slice(1))
    },
    compareEquipmentsValue (a, b) {
      // Use toUpperCase() to ignore character casing
      const valueA = a.value.toUpperCase()
      const valueB = b.value.toUpperCase()

      let comparison = 0
      if (valueA > valueB) {
        comparison = 1
      } else if (valueA < valueB) {
        comparison = -1
      }
      return comparison
    },
    getStyleNbFavoriteEquipment () {
      if (this.nbFavoriteEquipments > this.nbFavoriteEquipmentsMax) {
        return 'color: red;font-weight: bold;'
      } else {
        return ''
      }
    },
    selectedFavoriteEquipment (code, checked) {
      this.codesFavoritesEquipments[code] = checked
      if (checked) {
        this.nbFavoriteEquipments++
      } else {
        this.nbFavoriteEquipments--
      }
    },
    saveEquipments () {
      const selectedFavoritesEquipments = []
      for (const code in this.codesFavoritesEquipments) {
        if (this.codesFavoritesEquipments[code]) {
          selectedFavoritesEquipments.push(code)
          this.defaultEquipments.push({ code: code, value: this.$labels[code] })
        }
      }
      postAdvertiserEquipments(this.idEquipements, selectedFavoritesEquipments)
      if (this.defaultEquipments.length === 0) {
        this.defaultEquipments = this.loadDefaultEquipments()
      }
      this.dialogTableVisible = false
    },
    async getEquipments () {
      const equipments = await getAdvertiserEquipments()
      if (equipments && equipments.equipements) {
        this.idEquipements = equipments.id
        for (const equipment of equipments.equipements) {
          this.defaultEquipments.push({ code: equipment, value: this.$labels[equipment] })
          this.codesFavoritesEquipments[equipment] = true
          this.nbFavoriteEquipments++
        }
      }
      if (this.defaultEquipments.length === 0) {
        this.defaultEquipments = this.loadDefaultEquipments()
      }
    }
  },
  mounted () {
    this.getEquipments()
    this.defaultEquipments = this.loadDefaultEquipments()
    this.upperCaseFirstLetterOfValue(this.defaultEquipments)
    this.defaultEquipments.sort(this.compareEquipmentsValue)

    // comfort equipments: load, uppercase first letter and sort
    this.comfortEquipments = this.loadComfortEquipments()
    this.upperCaseFirstLetterOfValue(this.comfortEquipments)
    this.comfortEquipments.sort(this.compareEquipmentsValue)

    // security equipments: load, uppercase first letter and sort
    this.securityEquipments = this.loadSecurityEquipments()
    this.upperCaseFirstLetterOfValue(this.securityEquipments)
    this.securityEquipments.sort(this.compareEquipmentsValue)

    // other equipments: load, uppercase first letter and sort
    this.otherEquipments = this.loadOtherEquipments()
    this.upperCaseFirstLetterOfValue(this.otherEquipments)
    this.otherEquipments.sort(this.compareEquipmentsValue)

    // equipments: load and sort
    this.equipments = [...this.comfortEquipments, ...this.securityEquipments, ...this.otherEquipments]
      .filter(e => e.code !== 'equipements')
    this.equipments.sort(this.compareEquipmentsValue)
  }
}
</script>

<style scoped>
    .titrePopover {
        font-size: large;
        font-weight: bold;
        color: #21b1be;
        margin-bottom: 10px;
        word-wrap: break-word;
    }

    .textPopover {
        word-wrap: break-word;
    }

    .informationsComplementaires {
        height: 35px;
        width: 35px;
        border: none;
        color: #255662;
        background-color: white;
        margin-right: 25px;
    }

</style>
